import { Heading, TableHead, TableHeader, TableHeaderSelectAll, TableRow } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';
import type { Financing } from '../financing';

type FinancingTableOldHeaderProps = {
    allFinanceItemsSelected: boolean;
    items: Financing[];
    onSelectAllFinanceItems: (checked: boolean) => void;
};

export function FinancingTableOldHeader(props: FinancingTableOldHeaderProps) {
    const { items, allFinanceItemsSelected, onSelectAllFinanceItems } = props;
    const language = getSelectedLanguage();

    return (
        <TableHead>
            <TableRow>
                <TableHeader
                    colSpan={5}
                    itemScope
                >
                    <Heading size="medium">{language.request.processDetails}</Heading>
                </TableHeader>
                <TableHeader colSpan={13}>
                    <Heading size="medium">{language.finance.financingDetails}</Heading>
                </TableHeader>
            </TableRow>
            <TableRow>
                {items.length ? (
                    <TableHeaderSelectAll
                        checked={items.some((item) => item.checked) || allFinanceItemsSelected}
                        indeterminate={!allFinanceItemsSelected}
                        onSelect={(event) => onSelectAllFinanceItems((event.target as HTMLInputElement).checked)}
                    />
                ) : (
                    <TableHeader />
                )}

                <TableHeader>{language.common.processNumber}</TableHeader>
                <TableHeader>{language.common.creationDate}</TableHeader>
                <TableHeader>{language.common.txcs}</TableHeader>
                <TableHeader>{language.service.service}</TableHeader>
                <TableHeader>{language.finance.institution}</TableHeader>
                <TableHeader>{language.groups.group}</TableHeader>
                <TableHeader>{language.serviceDeclarationActivities.codeActiviteit}</TableHeader>
                <TableHeader>{language.organization.relationNumberAbbeviation}</TableHeader>
                <TableHeader>{language.finance.amount}</TableHeader>
                <TableHeader>{'TB'}</TableHeader>
                <TableHeader>{language.request.reasonNoInvoiceOrDeclarationAbbreviation}</TableHeader>
                <TableHeader>{language.request.fundingError}</TableHeader>
                <TableHeader>{language.request.fundingErrorInformationAbbreviation}</TableHeader>
                <TableHeader>{language.finance.runNumberShort}</TableHeader>
                <TableHeader>{language.finance.reprocessByShort}</TableHeader>
                <TableHeader>{language.finance.reprocessedOn}</TableHeader>
                <TableHeader></TableHeader>
            </TableRow>
        </TableHead>
    );
}
